import { render } from "./thumbnail.vue?vue&type=template&id=f63537a8&scoped=true&ts=true"
import script from "./thumbnail.ts?vue&type=script&lang=ts&external"
export * from "./thumbnail.ts?vue&type=script&lang=ts&external"

import "./thumbnail.vue?vue&type=style&index=0&id=f63537a8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63537a8"]])

export default __exports__